module.exports = __webpack_public_path__ + "static/media/family_19.a3498985.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_19.jpg
// module id = 5850
// module chunks = 0